<template>
    <v-container class="main-container">
        <ip-address-whitelist-component></ip-address-whitelist-component>
    </v-container>
</template>

<script>
    import IpAddressWhitelistComponent from "../../components/ipAddressWhitelist/IpAddressWhitelistComponent";
    export default {
        components: {
            'ip-address-whitelist-component': IpAddressWhitelistComponent,
        },
    };
</script>